import { Localization } from "../../../../../../common/localizable-component";
import { NavigationFlyoutLinkLocalization } from "./navigation-flyout-link-types";

export const NAVIGATION_FLYOUT_LINK_LOCALIZATION: Localization<NavigationFlyoutLinkLocalization> = {
  en: {
    ariaLabel: {
      default: "Navigate to {0}"
    }
  },
  de: {
    ariaLabel: {
      default: "Navigiere zu {0}"
    }
  },
  sv: {
    ariaLabel: {
      default: "Gå till {0}"
    }
  },
  nl: {
    ariaLabel: {
      default: "Navigeer naar {0}"
    }
  },
  it: {
    ariaLabel: {
      default: "Naviga su {0}"
    }
  },
  hu: {
    ariaLabel: {
      default: "Tovább a {0}"
    }
  },
  da: {
    ariaLabel: {
      default: "Gå til {0}"
    }
  },
  fr: {
    ariaLabel: {
      default: "Naviguer à {0}"
    }
  },
  es: {
    ariaLabel: {
      default: "Navega a {0}"
    }
  },
  pl: {
    ariaLabel: {
      default: "Przejdź do {0}"
    }
  },
  ro: {
    ariaLabel: {
      default: "Navigați la {0}"
    }
  },
  hr: {
    ariaLabel: {
      default: "Idite do {0}"
    }
  },
  cs: {
    ariaLabel: {
      default: "Přejděte na {0}"
    }
  },
  sl: {
    ariaLabel: {
      default: "Pojdite v {0}"
    }
  }
};
